export enum BalanceType {
  ORDERS = 'orders',
  DELIVERYPERSON = 'deliveryPerson',
}
